import styled from "styled-components";
import {Link, useLocation} from 'react-router-dom';
import {colors} from "../../common/colors";
import {SVG} from "../../common/svg";
import {routes} from "../../common/routes";
import {useDispatch, useSelector} from "react-redux";
import { RootState } from "src/store";
import {authSlice} from "../../features/authSlice";
import { useCookies } from 'react-cookie';
import { ACCESS_TOKEN, AUTH_TOKEN } from "src/common/util";

export default function Nav() {
  const location = useLocation();
  const dispatch = useDispatch();
  const { user } = useSelector((state:RootState) => state.auth);
  const [cookies, setCookie, removeCookie] = useCookies([ACCESS_TOKEN, AUTH_TOKEN]);

  const logout = () => {
    removeCookie(ACCESS_TOKEN, { path: '/' }); 
    removeCookie(AUTH_TOKEN, { path: '/' }); 
  }
  
  return (
    <Container>
      <div className="logo-wrapper">
        <div className="logo">
          <img src={SVG.logo_main} alt="로고" />
        </div>
      </div>
      <nav>
        <ul>
          {routes.routes.map(r => {
            const path_r = `/${r.path}`;
            const highlight_r = location.pathname.split('/')[1] === r.path;
            return (
              <NavItem
                key={r.title}
              >
                <Link to={r.defaultPath ?? path_r}>
                  <div className={`p-title ${highlight_r ? 'highlight' : ''}`}>
                    <div className="icon">
                      <img src={highlight_r ? r.activeIcon : r.icon} alt=""/>
                    </div>
                    <div className="title">{r.title}</div>
                  </div>
                </Link>
                {r.children ? (
                  <ul>
                    {r.children.map(rc => {
                      const path_rc = `${path_r}/${rc.path}`;
                      const highlight_rc = highlight_r && location.pathname.split('/')[2] === rc.path;
                      return (
                        <NavChildItem
                          key={rc.title}
                        >
                          <Link to={path_rc}>
                            <div className={`c-title ${highlight_rc ? 'highlight' : ''}`}>
                              • {rc.title}
                            </div>
                          </Link>
                        </NavChildItem>
                      )
                    })}
                  </ul>
                ) : null}
              </NavItem>
            )
          })}
        </ul>
      </nav>
      <div className="user-wrapper">
        <div className="user">
          <div><img src={SVG.logo_sub} alt="로고" /></div>
          <span>{user?.username} 관리자님</span>
        </div>
        <div
          className="signout"
          title="로그아웃"
          onClick={() => {
            dispatch(authSlice.actions.initAuth()); 
            logout();
          }}
        >
          <img src={SVG.icon.signout} alt="로그아웃" />
        </div>
      </div>
    </Container>
  )
}

const Container = styled.div`
  position: relative;
  min-width: 325px;
  height: 100%;
  background-color: ${colors.darkBlue};
  & * {
    font-family: 'KFAGothic';
  }
  
  &>.logo-wrapper {
    padding: 28px 0 28px 32px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.13);
    &>.logo {
      position: relative;
      width: 125px;
      height: 56px;
    }
  }
  &>.user-wrapper {
    position: absolute;
    padding: 0 23px;
    width: calc(100% - 23 * 2px);
    bottom: 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .user {
      display: flex;
      align-items: center;
      &>:first-child {
        margin-right: 12px;
      }
      &>:last-child {
        font-size: 14px;
        color: #FFF;
      }
    }
    .signout {
      cursor: pointer;
    }
  }
`

const NavItem = styled.li`
  padding: 22px 0 24px 34px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.13);
  
  color: ${colors.grey};
  &.active {
    color: #FFF;
  }
  
  & .p-title {
    display: flex;
    align-items: center;
    &.highlight {
      color: #FFF;
    }
    .icon {
      position: relative;
      width: 22px;
      height: 22px;
      margin-right: 16px;
    }
    .title {
      font-size: 18px;
    }
  }
  & ul {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    .c-title {
      font-size: 14px;
      &.highlight {
        color: #FFF;
      }
    }
  }
`

const NavChildItem = styled.li`
  padding-left: 30px;
`